import $ from 'jquery';

import domain from '../utils/getDomain';

$(document).ready(() => {
  if ($('.choose-user').length) {
    $.fancybox.open({
      src: '#choose-user',
      closeExisting: true,
      smallBtn: false,
      toolbar: false,
      touch: false,
    });
  }

  $('.choose-user [data-group]').on('click', e => {
    e.preventDefault();

    const group = $(e.currentTarget).attr('data-group');
    let formId = 19253;

    if (domain === 'https://radnuk.com.ua') {
      formId = 57316;
    }

    $('.choose-user .preloader').addClass('done');

    const args = {
      email: $('#user_id_popup').val(),
      'user-group': group
    };

    $.post(
      `${domain}/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback/`,
      args
    )
      .done(() => {
        $('.choose-user .preloader').removeClass('done');
        $('.choose-user__content').hide();
        $('.choose-user__success').show();
      })
      .fail(() => {
        console.log('error');
      });
  });
});
